import {
  BrowserRouter as Router, Redirect, Route, Switch
} from 'react-router-dom';
import { CameraView } from './component/CameraView';
import { CameraTake } from './component/CameraTake';
import { CardView } from './component/CardView';
import { CardFrontCamera } from './component/CardFrontCamera';
import { CardBackCamera } from './component/CardBackCamera';
import { CardVerifyPhotos } from './component/CardVerifyPhotos';
import { DownloadGuide } from './component/DownloadGuide';
import { DonorAgreement } from './component/DonorAgreement';
import { AuthorizationForDisclosure } from './component/AuthorizationForDisclosure';
import { AssignmentOfBenefit } from './component/AssignmentOfBenefit';
import { ThankYou } from './component/ThankYou';
import { Layout } from './component/shared/Layout';
import { StartPage } from './component/StartPage';
import { LoginPage } from './component/LoginPage';
import { NoProfile } from './component/NoProfile';
import { WelcomeProfile } from './component/WelcomeProfile/WelcomeProfile';
import { PersonalInfoForm } from './component/PersonalInfoForm';
import { InsuranceDetailsForm } from './component/InsuranceDetailsForm';
import { PrimaryCareProviderForm } from './component/PrimaryCareProviderForm';
import { EmergencyContactForm } from './component/EmergencyContactForm';
import { NotEnrolledSMS } from './component/NotEnrolledSMS';
import { PhoneVerification } from './component/PhoneVerification';

export const Routes = () => (
  <Router>
    <Switch>
      <Route exact path="/">
        <Redirect to="/start" />
      </Route>
      <Route exact path="/start">
        <Layout noHeader noFooter>
          <StartPage />
        </Layout>
      </Route>
      <Route exact path="/login">
        <Layout noFooter>
          <LoginPage />
        </Layout>
      </Route>
      <Route exact path="/no-profile">
        <Layout>
          <NoProfile />
        </Layout>
      </Route>
      <Route exact path="/welcome">
        <Layout>
          <WelcomeProfile />
        </Layout>
      </Route>
      <Route exact path="/camera-view">
        <Layout>
          <CameraView />
        </Layout>
      </Route>
      <Route exact path="/camera-take">
        <Layout noHeader noFooter>
          <CameraTake />
        </Layout>
      </Route>
      <Route exact path="/personal-info">
        <Layout noHeader>
          <PersonalInfoForm />
        </Layout>
      </Route>
      <Route exact path="/insurance-info">
        <Layout noHeader>
          <InsuranceDetailsForm />
        </Layout>
      </Route>
      <Route exact path="/primary-care-info">
        <Layout noHeader>
          <PrimaryCareProviderForm />
        </Layout>
      </Route>
      <Route exact path="/emergency-info">
        <Layout noHeader>
          <EmergencyContactForm />
        </Layout>
      </Route>
      <Route exact path="/phone-verification">
        <Layout>
          <PhoneVerification />
        </Layout>
      </Route>
      <Route exact path="/sms-not-enrolled">
        <Layout>
          <NotEnrolledSMS />
        </Layout>
      </Route>
      <Route exact path="/card-view">
        <Layout>
          <CardView />
        </Layout>
      </Route>
      <Route exact path="/card-front">
        <Layout noHeader noFooter>
          <CardFrontCamera />
        </Layout>
      </Route>
      <Route exact path="/card-back">
        <Layout noHeader noFooter>
          <CardBackCamera />
        </Layout>
      </Route>
      <Route exact path="/card-verify">
        <Layout>
          <CardVerifyPhotos />
        </Layout>
      </Route>
      <Route exact path="/download-guide">
        <Layout noHeader>
          <DownloadGuide />
        </Layout>
      </Route>
      <Route exact path="/donor-agreement">
        <Layout noHeader>
          <DonorAgreement />
        </Layout>
      </Route>
      <Route exact path="/authorization-agreement">
        <Layout noHeader>
          <AuthorizationForDisclosure />
        </Layout>
      </Route>
      <Route exact path="/assignment-agreement">
        <Layout noHeader>
          <AssignmentOfBenefit />
        </Layout>
      </Route>
      <Route exact path="/all-done">
        <Layout noHeader>
          <ThankYou />
        </Layout>
      </Route>
      <Route>
        <Redirect to="/" />
      </Route>
    </Switch>
  </Router>
);
